import React from 'react';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';

const Editor = React.lazy(() => import('./component').then((module) => ({ default: module.SSEditor })));

const LazyEditor = (props) => (
  <React.Suspense fallback={<LoadingIndicator />}>
    <Editor {...props} />
  </React.Suspense>
);

export default LazyEditor;
